<template>
  <section :class="['page-wrapper', openFrom || '', displayLayout]">
    <UserCenter
      v-if="source !== 'detailPage'"
      display="none"
      :page="page"
      ref="userCenter"
      :parentContainer="source === 'detailPage' ? '.games-detail-page ' : ''"
    />
    <activity-header :page="page" v-if="!openFrom" />
    <div
      :class="['lucky-draw-intro', region]"
      :style="{
        backgroundImage: `url(${topPic})`,
      }"
    ></div>

    <main
      class="main-section"
      :style="{
        backgroundImage: `url(${mainSectionBgConfig.bgImage})`,
        backgroundColor: `${mainSectionBgConfig.bgColor}`,
      }"
    >
      <div class="swiper-wrapper" :class="openFrom">
        <van-swipe
          autoplay="1500"
          vertical
          :show-indicators="false"
          :touchable="false"
          :style="{ background: swipeBgColor }"
        >
          <van-swipe-item v-for="(item, index) in swipeList" :key="index">
            {{ item }}
          </van-swipe-item>
        </van-swipe>
      </div>
      <lucky-grid
        :page="page"
        :inPopup="!!openFrom"
        :configData="luckyDrawInfo"
        ref="luckyGrid"
        @handleClose="handleClose"
        :isLogin="isLogin"
        :activityOffline="activityOffline"
        @onActivityIsOver="onActivityIsOver"
        @login="login"
      />
    </main>
  </section>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import luckydrawMixin from '@/mixins/activity/luckydraw.js'
  import LuckyGrid from '@/components/LuckyGrid'
  import UserCenter from '@/components/UserCenter'
  import ActivityHeader from '@/components/ActivityHeader'
  import { show } from '@/pages/firebase'
  import { getQuery } from '@/utils/utils'
  import { getLimitedStrList, checkIsColor } from '@/utils/tool'
  import { imgLoadedHandler } from '@/utils/image.js'
  import { shareSuccess } from '@/pages/firebase'
  import bus from '@/utils/bus'

  export default {
    name: 'lucky-draw',
    mixins: [luckydrawMixin],
    components: {
      LuckyGrid,
      UserCenter,
      ActivityHeader,
    },
    props: {
      openFrom: {
        type: String,
        default: '',
      },
      source: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        luckyDrawInfo: {}, //抽奖活动信息
        activityOffline: true, // 标记活动是否下线或暂停
        mainSectionBgConfig: {
          bgImage: require('@/assets/images/activities/luckydraw/lucky-draw-bg.png'),
          bgColor: '#0c0e31',
        },
      }
    },
    computed: {
      ...mapState(['region', 'gameName', 'userInfo', 'luckyDrawData']),
      ...mapGetters(['displayLayout']),
      page() {
        return this.openFrom === 'popup' ? this.gameName : this.$route.name //'luckyDraw'
      },
      extraInfo() {
        const temp =
          this.luckyDrawData?.extraInfo || this.luckyDrawInfo?.extraInfo || {}
        return temp
      },
      isLogin() {
        return !!(this.userInfo && this.userInfo.kicoinId)
      },
      topPic() {
        const { detailPagePic, popPic } = this.extraInfo
        if (!detailPagePic || !popPic) {
          return require(`@/assets/images/activities/luckydraw/lucky-draw-intro-popup.png`)
        } else {
          return encodeURI(this.openFrom === 'popup' ? popPic : detailPagePic)
        }
      },
      swipeBgColor() {
        const { winCarouselColor } = this.extraInfo
        return (
          (winCarouselColor &&
            checkIsColor(winCarouselColor) &&
            winCarouselColor) ||
          'linear-gradient(270deg, #8831FF 0%, #4360FF 100%)'
        )
      },
      swipeList() {
        const { winCarouselData = '' } = this.extraInfo
        let strArr = winCarouselData?.split('\n') || []
        let limitCount = this.openFrom === 'popup' ? 30 : 40
        return getLimitedStrList(strArr, limitCount)
      },
    },
    created() {
      if (!process.client) return
      show({ page: this.page })
      if (this.page === 'luckyDraw' && getQuery('source') === 'share') {
        shareSuccess({ page: this.page, share_name: getQuery('channelId') })
      }
      const activitySource = getQuery('activitySource')
      const source = getQuery('source')
      this.getActivityInfos({
        queryOnline: 0,
        activityIdString: getQuery('activityId'),
        activitySource: activitySource || source, //优先取 activitySource
      }).then((data) => {
        // window.console.log('------ 抽奖活动信息 ： ', data)
        if (data.activityStatus * 1) {
          // 活动状态 1待激活 2已激活 3已停止 4已下线
          this.activityOffline = data.activityStatus * 1 !== 2
        }
        this.luckyDrawInfo = data
        this.getImage()
      })
    },
    beforeDestroy() {
      bus.$off('login')
    },
    methods: {
      login(data) {
        // this.$refs.userCenter.loginBtn(data)
        bus.$emit('login', data)
      },
      handleClose() {
        this.$emit('handleClose')
      },
      onActivityIsOver() {
        this.activityOffline = true
      },
      initLuckyDraw() {
        this.$refs.luckyGrid.initLuckyDraw()
      },
      getImage() {
        const { backgroundPic, pageBackgroundColor = '#0c0e31' } =
          this.extraInfo
        imgLoadedHandler(
          backgroundPic,
          require('@/assets/images/activities/luckydraw/lucky-draw-bg.png')
        ).then((res) => {
          this.mainSectionBgConfig = {
            bgImage: res,
            bgColor: pageBackgroundColor,
          }
        })
      },
    },
  }
</script>
<style lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
<style lang="scss">
  .page-wrapper {
    width: 100vw;
    height: 100vh;
    background-color: #0c0e31;
    .lucky-draw-intro {
      width: 100%;
      height: 600px;
      background-color: #0c0e31;
      background-repeat: no-repeat;
      background-size: cover;
      position: relative;
      text-align: center;
      background-image: url('~@/assets/images/activities/luckydraw/lucky-draw-intro-popup.png');
      .title {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 95px;
        color: #feed00;
        font: 700 70px/82px 'Noto Sans';
        text-shadow: 0px 0px 5px rgba(0, 0, 0, 0.66);
      }
      .desc {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 50px;
        color: #fff;
        font: 700 32px/37px 'Noto Sans';
        text-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.61);
      }
    }
    .main-section {
      width: 100%;
      height: auto;
      box-sizing: border-box;
      padding: 0 48px;
      color: #fff;
      font-family: 'Noto Sans';
      background-image: url('~@/assets/images/activities/luckydraw/lucky-draw-bg.png');
      background-repeat: no-repeat;
      background-color: #0c0e31;
      background-size: cover;

      .swiper-wrapper {
        padding: 0 100px;
        box-sizing: border-box;
        .van-swipe {
          border-radius: 80px;
          width: 100%;
          height: 70px;
          font-size: 33px;
          line-height: 70px;
          margin: 0 auto;
          text-align: center;
        }
        &.popup {
          padding: 0 80px;
          .van-swipe {
            height: 54px;
            font-weight: 28px;
            line-height: 54px;
          }
        }
      }
    }
    .note-section {
      width: 100%;
      box-sizing: border-box;
      padding: 68px 92px;
      background-color: #0c0e31;
    }

    &.popup {
      width: 843px;
      height: 100%;

      .lucky-draw-intro {
        width: 100%;
        height: 345px;
        background-image: url('~@/assets/images/activities/luckydraw/lucky-draw-intro-popup.png');
        .title {
          bottom: 54px;
          font: 700 60px/70px 'Noto Sans';
        }
        .desc {
          bottom: 20px;
          font: 700 28px/32px 'Noto Sans';
        }
      }
      .main-section {
        .swiper-wrapper {
          margin: 0 auto;
          box-sizing: border-box;
          .van-swipe {
            font-size: 28px;
            width: 100%;
          }
        }
      }
      .lucky-draw-wrapper {
        width: 100%;
        .lucky-grid-wrapper {
          width: 770px;
          height: 777px;

          .lucky-canvas {
            width: 648px;
            height: 648px;
          }
        }
      }
      .btn-wrapper {
        height: 100px;
        & > div {
          font-size: 22px;
          line-height: 30px;
          margin: 0 10px;
          & > div img {
            width: 28px;
            height: 20px;
          }
        }
      }
      .entry-wrapper {
        margin-top: 20px;
      }

      .activity_rule_wrapper {
        .popup-wrapper.van-popup {
          width: 70vw;
        }
      }
    }
  }
</style>
